import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import qs from 'qs';
import { isEmpty } from 'lodash';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import { withBuyers, withSellers } from 'containers/ContactsList';
import { currentUserRoleSelector } from 'redux/auth/selectors';
import OrderSheetCard from './components/OrderSheetCard';
import {
  getCartLocalStorage,
  setCartLocalStorage,
  clearCartLocalStorage
} from 'helpers/utils';

class OrderSheetContainer extends Component {
  static propTypes = {
    currentUserRole: PropTypes.string.isRequired,
    history: PropTypes.shape({
      location: PropTypes.shape({
        search: PropTypes.string,
      }).isRequired,
      push: PropTypes.func.isRequired,
    }).isRequired,
  };

  constructor(props) {
    super(props);
    this.init(props.currentUserRole);
  }

  state = {
    invoice: {
      items: {},
    },
    open: false,
    currentOrderSheetCardId: -1,
    openOrdersheetId: -1,
    cartEmpty: true,
  };

  componentWillMount() {
    const { history } = this.props;
    const { deliveryDate } = qs.parse(history.location.search.substring(1));
    const invoiceLocalStorage = getCartLocalStorage();
    if (!deliveryDate && invoiceLocalStorage.deliveryDate) {
      const publicPathname = history.location.pathname;
      history.push(`${publicPathname}?deliveryDate=${invoiceLocalStorage.deliveryDate}`);
    }
  }

  componentWillReceiveProps({ currentUserRole }) {
    if (this.props.currentUserRole !== currentUserRole) {
      this.init(currentUserRole);
    }
  }

  setInvoice = (newInvoice) => {
    this.setState({ invoice: newInvoice, cartEmpty: isEmpty(newInvoice.items) });
    setCartLocalStorage(newInvoice);
  }

  setExpanded = (expanded) => {
    const { history } = this.props;
    const { deliveryDate } = qs.parse(history.location.search.substring(1));
    this.setState({ currentOrderSheetCardId: expanded }, () => {
      history.push(expanded === -1 ? '/order' : `/order?suid=${expanded}&deliveryDate=${deliveryDate || ''}`);
    });
  }

  setOpen = (open, orderSheetId = -1) => {
    this.setState({ open, openOrdersheetId: orderSheetId });
  }

  handleClose = (confirm) => {
    if (confirm) {
      const { history } = this.props;
      const { deliveryDate } = qs.parse(history.location.search.substring(1));
      clearCartLocalStorage();
      this.setState({ invoice: { items: {} }, cartEmpty: true, open: false, currentOrderSheetCardId: this.state.openOrdersheetId }, () => {
        history.push(this.state.openOrdersheetId === -1 ? '/order' : `/order?suid=${this.state.openOrdersheetId}&deliveryDate=${deliveryDate || ''}`);
      });
    } else {
      this.setState({ open: false });
    }
  }

  init(currentUserRole) {
    const { location } = this.props;
    const { org } = qs.parse(location.search.slice(1));
    const isFarm = currentUserRole === 'Seller';

    this.WrappedOrderSheet = isFarm ? withBuyers(OrderSheetCard) : withSellers(OrderSheetCard, false ,org);
  }


  render() {
    const { WrappedOrderSheet } = this;
    const { currentUserRole, history } = this.props;
    const isRest = currentUserRole === 'Buyer';
    const { suid, deliveryDate } = qs.parse(history.location.search.substring(1));

    return (
      <React.Fragment>
        <WrappedOrderSheet
          deliveryDate={deliveryDate}
          helper="order-sheets"
          history={history}
          isRest={isRest}
          location={history.location}
          onCreateContactSuccess={() => history.push('/order')}
          push={history.push}
          invoice={this.state.invoice}
          setInvoice={this.setInvoice}
          setOpen={this.setOpen}
          currentOrderSheetCardId={this.state.currentOrderSheetCardId}
          cartEmpty={this.state.cartEmpty}
          setDeliveryDate={(expanded, date) => history.push(
            `/order?suid=${expanded}${date ? `&deliveryDate=${date}` : ''}`,
          )}
          setExpanded={this.setExpanded}
          suid={suid}
        />
        <Dialog
          open={this.state.open}
          onClose={() => this.handleClose(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">Confirmation</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Items in the Cart will not be saved. Are you sure you want to leave?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => this.handleClose(true)} color="primary">
              Yes
            </Button>
            <Button onClick={() => this.handleClose(false)} color="primary" autoFocus>
              No
            </Button>
          </DialogActions>
        </Dialog>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  currentUserRole: currentUserRoleSelector(state),
});

export default connect(mapStateToProps)(OrderSheetContainer);
